<template>
  <section class="cost-section now">
    <table class="totals">
      <tbody>
        <tr>
          <td>
            <translate class="amount" tag="h4"> Payable now </translate>
          </td>
          <td class="amount">
            <pu-price :price="price" :display-original-price="true" />
          </td>
        </tr>
        <tr class="info">
          <td colspan="2">
            <p>
              <translate
                v-if="
                  campsiteRefundPolicy === 'within' &&
                  !isNotRefundableAfterDate &&
                  !refundUntilDate
                "
                :tt="{ campsiteName }"
              >
                {campsiteName} will bill you the total amount now
                (non-refundable).
              </translate>
              <template v-else>
                <translate :tt="{ campsiteName }">
                  {campsiteName} will bill you the total amount now.
                </translate>
                <br />
                <translate :tt="{ commission: depositPercent }">
                  This includes a {commission, puNumber, style:percent}
                  non-refundable deposit.
                </translate>
                <translate
                  v-if="isRefundableAfterToday"
                  :tt="{ refundUntilDate }"
                >
                  Balance refunds available until {refundUntilDate, puDate,
                  full}
                </translate>
              </template>
            </p>
          </td>
        </tr>
      </tbody>
    </table>
  </section>
</template>
<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { SimpleMoney } from '~/utility/money'

@Component
class StripePaymentImmediate extends Vue {
  @Prop()
  campsiteName: string

  @Prop()
  price: SimpleMoney

  @Prop()
  depositPercent: number

  @Prop()
  balanceDueDate: string

  @Prop()
  refundUntilDate: string

  @Prop()
  campsiteRefundPolicy: string

  get isNotRefundableAfterDate() {
    return (
      this.refundUntilDate &&
      this.balanceDueDate &&
      this.refundUntilDate === this.balanceDueDate
    )
  }

  get isRefundableAfterToday() {
    const today = new Date()
    const refundableDate = new Date(this.refundUntilDate)
    return refundableDate > today
  }
}

export default toNative(StripePaymentImmediate)
</script>
<style scoped>
p {
  margin-top: 1em;
}
</style>
